import KmPopper from './main.vue'
KmPopper.install = function (vue) {
  vue.component(KmPopper.name, KmPopper)
}
export default KmPopper



// WEBPACK FOOTER //
// ./src/ui/components/km-popper/index.js